// Helper function to chunk an array into smaller arrays of a specific size
export default function (array, chunkSize) {
  const results = [];

  while (array.length) {
    results.push(array.splice(0, chunkSize));
  }

  return results;
}
